const styles = require('../components/MentionComposeStyles.scss');

export default function getMentionClassName() {
    return styles.mentions;
}
